import React from 'react'

import { BodyText, MessagePanel, Label } from '@pb/components'

import styles from './EmptyState.scss'

const EmptyState: React.FC = () => (
  <MessagePanel
    className={styles.emptyStateContainer}
    title={<Label copyKey="omni.hmxklarna.todo.tab.no.invoices.title" />}
  >
    <BodyText className={styles.metaTextColor}>
      <Label copyKey="omni.hmxklarna.todo.tab.no.invoices.explanation" />
    </BodyText>
  </MessagePanel>
)

export default EmptyState
